import { useGetAgents } from '@shared/hooks/use-get-agents';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import type { FC } from 'react';
import { useMemo, useState } from 'react';

type AgentsSelectorProps = Omit<SelectProps<number>, 'options' | 'loading'> & {
  placeholder?: string;
};

export const AgentsSelector: FC<AgentsSelectorProps> = ({ placeholder, ...props }) => {
  const { agents, isLoading, refetch } = useGetAgents();
  const [search, setSearch] = useState('');

  const options = useMemo(() => {
    const items = agents || [];
    const filtered = search
      ? items.filter((agent) => agent.name.toLowerCase().includes(search.toLowerCase()))
      : items;

    return filtered.map((agent) => ({
      label: agent.name,
      value: agent.id,
    }));
  }, [agents, search]);

  return (
    <Select
      {...props}
      showSearch
      allowClear
      placeholder={placeholder}
      loading={isLoading}
      filterOption={false}
      options={options}
      onSearch={(value) => setSearch(value)}
      onClear={() => setSearch('')}
      onDropdownVisibleChange={(open) => {
        if (open) {
          setSearch('');
          refetch();
        }
      }}
    />
  );
};
